export const alignEventProperties = (event) => {
  event.zones &&
    event.zones.map((zone) => {
      zone.offers &&
        zone.offers.map((offer) => {
          if (offer.hasOwnProperty('aXSPromotion')) {
            Object.assign(offer, { axsPromotion: offer.aXSPromotion });
            delete offer.aXSPromotion;
          }
        });
    });
  return event;
};



// WEBPACK FOOTER //
// ./src/common/lib/Events/index.js